import { transform } from 'dto/transformer';
import { IDeploymentOptions } from './deployment-dto';

export enum DeploymentGroupType {
    ASSURE = 'ASSURE',
    RAPTOR = 'RAPTOR',
}

export interface IDeploymentGroupQuery {
    includeDeployments?: 0 | 1;
}

export interface IOutOfServiceSettings {
    enableServiceWindow: boolean;
    serviceWindowStart: string | null;
    serviceWindowEnd: string | null;
    allowSendLogs: boolean;
}

export interface CreateDeploymentGroupDetailsProps {
    label: string;
    accountUuid: string;
    deviceGroupIds: number[];
    outOfServiceSettings?: IOutOfServiceSettings;
    type?: DeploymentGroupType;
}

export interface UpdateDeploymentGroupDetailsProps {
    label?: string;
    deviceGroupIds?: number[];
    outOfServiceSettings?: IOutOfServiceSettings;
}

export class DeploymentGroupDto {
    constructor(private readonly _object: Record<string, any> = {}) {
    }

    get key(): number {
        return this.id;
    }

    get id(): number {
        return this._object['id'] || 0;
    }

    get value(): number {
        return this.id;
    }

    get label(): string {
        return this._object['label'] || '';
    }

    get accountUuid(): string {
        return this._object['accountUuid'] || '';
    }

    get awsAccountId(): string {
        return this._object['awsAccountId'] || '';
    }

    get type(): DeploymentGroupType {
        if (Object.values(DeploymentGroupType).includes(this._object['type'])) {
            return this._object['type'];
        }
        return DeploymentGroupType.ASSURE;
    }

    get outOfServiceSettings(): IOutOfServiceSettings | undefined {
        return this._object['outOfServiceSettings'];
    }

    get deployments(): IDeploymentOptions[] {
        return this._object['deployments'] || [];
    }

    get deviceGroups(): { id: number }[] {
        return this._object['deviceGroups'] as { id: number }[];
    }

    get createdAt(): Date {
        return this._object['createdAt'] ? new Date(this._object['createdAt']) : null;
    }

    get updatedAt(): Date {
        return this._object['updatedAt'] ? new Date(this._object['updatedAt']) : null;
    }

    get raw(): Record<string, any> {
        return this._object;
    }
}

export interface IDisplayDeploymentGroup {
    key: number;
    id: number;
    value: number;
    label: string;
    displayLabel: string;
    accountUuid: string;
    type: DeploymentGroupType;
    outOfServiceSettings?: IOutOfServiceSettings;
    deployments?: IDeploymentOptions[];
    accountName: string;
    targetDeviceGroupNames?: string[];
    deviceGroupIds?: number[];
    deviceGroupLabels?: string[];
    deviceGroupLabelAsString?: string;
    isSharedGroup?: boolean;
}
